// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/kiosk/CategoriesList/style.scss
// module id = 64
// module chunks = 0